import { requiredWhenAsked } from '../completion';
import { text, yesNo } from './fields';

const FULL_TIME_PREFIX = 'f_t';
const PART_TIME = 'p_t';

const STUDENT_TYPE_OPTIONS = [
  { label: 'Full-Time K-12', value: 'f_tK_12' },
  { label: 'Full-Time Post 12', value: 'f_tPost12' },
  { label: 'Part-Time', value: PART_TIME },
];

const GRID = { xs: 12, md: 4 };

const FULL_TIME_QUESTIONS = [
  ['TANFAssistance', '1. TANF Assistance'],
  ['jobTrainingProgram', '2. Job Training Program'],
  ['singleParentDependantChild', '3. Single Parent/Dependent Child'],
  ['marriedJointReturn', '4. Married/Joint Return'],
  ['fosterProgram', '5. Foster Program'],
];
const OTHER_STATUS = 'otherStudentStatus';

const clear = (when) => [
  ...FULL_TIME_QUESTIONS.map(([target]) => ({
    type: 'updateField',
    target,
    value: null,
    when,
  })),
  { type: 'updateField', target: OTHER_STATUS, value: '', when },
];

// The full-time questions only apply to a full-time student.
const onlyFullTime = (isLocked) => ({
  watchFields: ['studentType'],
  disabled: ({ getValues }) =>
    isLocked ||
    !String(getValues('studentType') ?? '').startsWith(FULL_TIME_PREFIX),
});

const buildStudentInformation = ({ isLocked, employedStatusId }) => {
  const required = (name) => ({
    rules: { required: requiredWhenAsked(name, { employedStatusId }) },
  });
  return {
    name: 'studentInformation',
    title: 'STUDENT INFORMATION',
    titleVariant: 'subsection',
    container: 'default',
    divider: true,
    disabled: isLocked,
    fields: [
      {
        ...yesNo('isStudent', 'Are you a current student?', {
          xs: 12,
          md: 4,
        }),
        ...required('isStudent'),
        changeActions: [
          {
            type: 'updateField',
            target: 'studentType',
            value: null,
            when: { eq: 'no' },
          },
          ...clear({ eq: 'no' }),
        ],
      },
      {
        variant: 'radioGroup',
        name: 'studentType',
        label: 'If yes, are you:',
        options: STUDENT_TYPE_OPTIONS,
        sx: { flexDirection: 'row' },
        ...required('studentType'),
        watchFields: ['isStudent'],
        changeActions: [
          {
            type: 'updateField',
            target: 'isStudent',
            value: 'yes',
            when: { in: STUDENT_TYPE_OPTIONS.map(({ value }) => value) },
          },
          ...clear({ eq: PART_TIME }),
        ],
        GridProps: { xs: 12, md: 8 },
      },
      {
        variant: 'caption',
        children:
          'If full-time, select the options below that describe your student status:',
        GridProps: { xs: 12 },
      },
      ...FULL_TIME_QUESTIONS.map(([name, label]) => ({
        ...yesNo(name, label, GRID),
        ...onlyFullTime(isLocked),
        ...required(name),
      })),
      {
        ...text(OTHER_STATUS, '6. Other Student Status', GRID),
        ...onlyFullTime(isLocked),
      },
    ],
  };
};

export default buildStudentInformation;
